<template>
  <IconWrapper name="loading" :color="color" fillMode="fill">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.2"
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM3.21743 12C3.21743 16.8505 7.14952 20.7826 12 20.7826C16.8505 20.7826 20.7826 16.8505 20.7826 12C20.7826 7.14952 16.8505 3.21743 12 3.21743C7.14952 3.21743 3.21743 7.14952 3.21743 12Z"
        fill="#1B1B1E"
      />
      <path
        class="rotating-path"
        d="M21.9154 13.298C22.1721 11.3369 21.8415 9.34375 20.9655 7.57054C20.0894 5.79734 18.7072 4.32373 16.9937 3.33608C15.2801 2.34843 13.3121 1.89109 11.3387 2.02189C9.36517 2.1527 7.4748 2.86577 5.90657 4.07093L6.65637 5.0466C8.03162 3.98973 9.68939 3.3644 11.42 3.2497C13.1507 3.13499 14.8765 3.53606 16.3792 4.40218C17.8819 5.2683 19.094 6.56057 19.8623 8.11558C20.6305 9.6706 20.9204 11.4185 20.6953 13.1383L21.9154 13.298Z"
        fill="#1B1B1E"
      />
    </svg>
  </IconWrapper>
</template>

<script setup lang="ts">
import IconWrapper from './wrapper/wrapper.vue'

import type { ColorsType } from '@/types'

defineProps<{
  color: ColorsType
}>()
</script>
